import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-差旅报销申请",
  "use": "icon-差旅报销申请-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 16 16\" id=\"icon-差旅报销申请\">\n<style type=\"text/css\">\n\t#icon-差旅报销申请 .st0{stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n</style>\n<path d=\"M4.8,4.6v6.8h1.4v0.9H4.3c-0.3,0-0.5-0.2-0.5-0.5l0,0V4.1c0-0.3,0.2-0.5,0.5-0.5l0,0h7.3c0.3,0,0.5,0.2,0.5,0.5c0,0,0,0,0,0\n\tv5.2h-0.9V4.6H4.8z M7.5,9.1V7.7H6.1V6.8h1.2L6.4,5.9L7,5.3L8,6.2l0.9-0.9l0.6,0.6L8.6,6.8h1.2v0.9H8.4v1.4C8.4,9.1,7.5,9.1,7.5,9.1\n\tz\" />\n<path d=\"M13.3,10.3c-0.2-0.3-0.6-0.4-0.9-0.2l-1.5,0.8L8.8,9.8L8,10.2l1.6,1.5l-1.2,0.7l-1-0.5l-0.6,0.3l1.9,1.2\n\tc0.1,0.1,0.3,0.1,0.5,0l0.7-0.4l3.2-1.8C13.4,11,13.5,10.6,13.3,10.3C13.3,10.3,13.3,10.3,13.3,10.3\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/差旅报销申请.svg
// module id = Kuy1
// module chunks = 166